import { Button, Group, Loader, SegmentedControl, Stack, Title } from '@mantine/core';
import { YearPickerInput } from '@mantine/dates';
import moment from 'moment';
import { useState } from 'react';

import { BatchTypeEnum, EORIGIN_DATE_FORMAT } from '@e-origin/shared';

import { DatePickerInput } from '@components';
import { useGenerateCustomsRegister } from '@hooks/batch';

interface CustomsRegisterFormProps {
  title: string;
  batchType: BatchTypeEnum;
  groupByShippingMarks?: boolean;
}

export const CustomsRegisterForm = ({ title, batchType, groupByShippingMarks }: CustomsRegisterFormProps) => {
  const [searchType, setSearchType] = useState<'date' | 'year'>('date');
  const [startDate, setStartDate] = useState(moment().toDate());
  const [endDate, setEndDate] = useState(moment().toDate());
  const [selectedYear, setSelectedYear] = useState<Date | null>(moment().toDate());

  const generateCustomsRegisterMutation = useGenerateCustomsRegister();
  const [isLoading, setIsLoading] = useState(false);

  const handleGenerateRegister = async () => {
    setIsLoading(true);

    if (searchType === 'year') {
      await generateCustomsRegisterMutation.mutateAsync({
        year: moment(selectedYear).format('YYYY'),
        batchType,
        groupByShippingMarks,
      });
    } else {
      await generateCustomsRegisterMutation.mutateAsync({
        startDate: moment(startDate).format(EORIGIN_DATE_FORMAT),
        endDate: moment(endDate).format(EORIGIN_DATE_FORMAT),
        batchType,
        groupByShippingMarks,
      });
    }

    setIsLoading(false);
  };

  return (
    <Stack gap="xl">
      <Title order={2}>{title}</Title>

      <SegmentedControl
        value={searchType}
        onChange={(value) => setSearchType(value as 'date' | 'year')}
        data={[
          { label: 'By date range', value: 'date' },
          { label: 'By year', value: 'year' },
        ]}
        w={300}
      />

      {searchType === 'date' ? (
        <>
          <DatePickerInput label="Start date" value={startDate} onChange={(value: Date) => setStartDate(value)} clearable={true} w={300} />
          <DatePickerInput label="End date" value={endDate} onChange={(value: Date) => setEndDate(value)} clearable={true} w={300} />
        </>
      ) : (
        <YearPickerInput value={selectedYear} onChange={setSelectedYear} clearable={true} w={300} />
      )}

      <Group>
        <Button leftSection={isLoading && <Loader color="white" />} onClick={handleGenerateRegister} disabled={isLoading} variant="filled" size="lg">
          Generate register
        </Button>
      </Group>
    </Stack>
  );
};
